// import React, { useState, useEffect } from 'react'
// import axios from 'axios'
// import './Sidebarr.css'
// import { createBrowserHistory } from 'history'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import Header from '../Components/Header'
// import Footer from '../Components/Footer'
// import { Card, Button, CardText } from 'react-bootstrap'
// import {
//   faUser,
//   faList,
//   faShieldAlt,
//   faBell,
//   faColumns,
//   faTrophy,
//   faCog,
//   faEdit,
//   faSignOutAlt,
// } from '@fortawesome/free-solid-svg-icons'
// import {
//   faInstagram,
//   faTwitter,
//   faFacebook,
//   faWhatsapp,
// } from '@fortawesome/free-brands-svg-icons'
// import { FaTrophy, FaChartBar, FaBullseye } from 'react-icons/fa'
// import StudentSdebar from './StudentSdebar'

// import defaultPic from '../Images/default.jpeg'
// import EditProfileModal from './EditProfileModal'

// import { useNavigate } from 'react-router-dom'

// const history = createBrowserHistory()

// const Profile = () => {
//   const [user, setUser] = useState({
//     name: '',
//     email: '',
//     bio: '',
//     profile: '',
//     tagline: '',
//   })
//   const [showEditProfileModal, setEditProfileModal] = useState(false)

//   const handleNavigation = (path) => {
//     history.push(path)
//   }

//   const navigate = useNavigate()

//   const token = localStorage.getItem('jwttoken')

//   const handleEditProfile = () => {}
//   useEffect(() => {
//     axios
//       .get('https://kaasbackend.vetrinahealthcare.com/lms/user/', {
//         headers: {
//           accept: 'application/json',
//           Authorization: 'Bearer ' + token,
//         },
//       })
//       .then((response) => {
//         setUser({
//           name: response.data.first_name + ' ' + response.data.last_name,
//           email: response.data.email,
//           bio: response.data.bio,
//           tagline: response.data.tagline,
//           profile: response.data.profile_pic,
//         })
//         console.log(response.data)
//       })
//       .catch((error) => {
//         console.error('Error:', error.response.status)
//         if (error.response.status === 401) {
//           navigate('/Log')
//         }
//       })
//   }, [showEditProfileModal])

//   return (
//     <div style={{ marginTop: '80px' }}>
//       <Header />
//       <div className='container-fluid'>
//         <div className='row Profile_info_row p-0'></div>
//       </div>
//       <div
//         className='wrapper'
//         style={{
//           backgroundImage:
//             'linear-gradient(180.06deg, #E9F7FA 29.88%, #F8EEF5 58.49%)',
//         }}
//       >
//         <StudentSdebar />

//         <div className='main p-3' style={{ backgroundColor: 'transparent' }}>
//           <div
//             className='text-center border rounded mx-auto text-light mb-4 p-1'
//             style={{
//               background:
//                 'linear-gradient(to right, #3953A3, #7D52A0, #8852A0, #B8529E)',
//               width: '80%',
//               maxWidth: '300px',
//             }}
//           >
//             <h1 style={{ fontSize: '24px' }}>My Profile</h1>
//           </div>
//           <div className='container-fluid '>
//             <div className='row  mb-4'>
//               <div className='col-2 text-center'>
//                 <img
//                   src={user.profile ? user.profile : defaultPic}
//                   alt='User Profile'
//                   style={{
//                     height: '200px',
//                     width: '200px',
//                     borderRadius: '50%',
//                     objectFit: 'cover',
//                     border: '8px solid white', // Add a border around the icon with your chosen color
//                     boxShadow: '0 0 0 5px white, 0 4px 8px rgba(0, 0, 0, 0.1)',
//                     marginTop: '70px',
//                     marginLeft: '10px',
//                     display: 'block', // Ensure the image is centered
//                     position: 'relative', // Position it relative to the card below
//                     zIndex: '1', // Place it above the card
//                   }}
//                   onError={(e) => {
//                     e.target.src = defaultPic
//                   }}
//                 />
//               </div>

//               <div className='col-md-10 d-flex justify-content-center'>
//                 <Card
//                   className='border-0 shadow-lg text-start p-5'
//                   style={{ width: '100%' }}
//                 >
//                   <Card.Body>
//                     <Card.Title>
//                       <h2 className='mb-2 text-danger'>{user.name}</h2>
//                       {/* <h4>Always willing to learn and explore new things</h4> */}
//                     </Card.Title>
//                     <Card.Text className='text-muted mb-4'>
//                       {user.tagline
//                         ? user.tagline
//                         : 'Turning ideas into reality, one line of code at a time. Driven by passion, powered by purpose.'}
//                     </Card.Text>
//                     <Card.Text className='lead' style={{ color: '#333' }}>
//                       {user.bio ? user.bio : user.name}
//                     </Card.Text>

//                     <div
//                       className='d-flex justify-content-end align-items-center mb-4'
//                       style={{ width: '100%' }}
//                     >
//                       {/* Social Media Icons */}
//                       <div className='d-flex justify-content-right align-items-center'>
//                         <a
//                           href=' '
//                           className='text-dark me-3'
//                           title='Instagram'
//                           onClick={() =>
//                             window.open('your-instagram-link', '_blank')
//                           }
//                         >
//                           <FontAwesomeIcon
//                             icon={faInstagram}
//                             size='2x'
//                             style={{ color: 'red' }}
//                           />
//                         </a>
//                         <a
//                           href=' '
//                           className='text-dark me-3'
//                           title='Twitter'
//                           onClick={() =>
//                             window.open('your-twitter-link', '_blank')
//                           }
//                         >
//                           <FontAwesomeIcon
//                             icon={faTwitter}
//                             size='2x'
//                             style={{ color: 'blue' }}
//                           />
//                         </a>
//                         <a
//                           href=' '
//                           className='text-dark me-3'
//                           title='Facebook'
//                           onClick={() =>
//                             window.open('your-facebook-link', '_blank')
//                           }
//                         >
//                           <FontAwesomeIcon
//                             icon={faFacebook}
//                             size='2x'
//                             style={{ color: 'blue' }}
//                           />
//                         </a>
//                         <a
//                           href=' '
//                           className='text-dark'
//                           title='WhatsApp'
//                           onClick={() =>
//                             window.open('your-whatsapp-link', '_blank')
//                           }
//                         >
//                           <FontAwesomeIcon
//                             icon={faWhatsapp}
//                             size='2x'
//                             style={{ color: 'green' }}
//                           />
//                         </a>
//                       </div>

//                       {/* Edit Profile Button */}
//                       <div className='ms-auto'>
//                         {/* <Button
//                           style={{
//                             backgroundColor: '#B8529E',
//                             color: 'white',
//                             border: 'none',
//                             marginLeft: '20px',
//                             width: 'auto',
//                             whiteSpace: 'nowrap',
//                             padding: '10px 20px',
//                           }}
//                           size='lg'
//                           onClick={() => setEditProfileModal(true)}
//                         >
//                           <FontAwesomeIcon icon={faUser} className='me-2' />
//                           Edit Profile
//                         </Button> */}
//                       </div>

//                       {/* Edit Profile Modal */}
//                       {showEditProfileModal && (
//                         <EditProfileModal
//                           setShow={setEditProfileModal}
//                           show={showEditProfileModal}
//                           onEditProfile={handleEditProfile}
//                           onClose={() => setEditProfileModal(false)}
//                         />
//                       )}
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </div>
//             </div>

//             <div className='row mb-4'>
//               <div className='col-md-12'>
//                 {/* <Card className="border-0 shadow-lg"> */}
//                 <Card.Body>
//                   <div className='row'>
//                     <div className='col-md-4'>
//                       <Card className='border-0 shadow-lg'>
//                         <Card.Body style={{ textAlign: 'center' }}>
//                           {' '}
//                           {/* Center the content */}
//                           <button
//                             style={{
//                               backgroundColor: '#B8529E',
//                               color: 'white',
//                               border: 'none',
//                               borderRadius: '5px',
//                               padding: '10px 20px',
//                               cursor: 'pointer',
//                               marginBottom: '10px',
//                             }}
//                           >
//                             <FaTrophy /> Top Performer
//                           </button>
//                           <ul>
//                             <li>Celebrating Excellence</li>
//                             <li>Champion of the Month</li>
//                             <li>Leaderboard Leader</li>
//                           </ul>
//                         </Card.Body>
//                       </Card>
//                     </div>

//                     <div className='col-md-4'>
//                       <Card className='border-0 shadow-lg'>
//                         <Card.Body style={{ textAlign: 'center' }}>
//                           {' '}
//                           {/* Center the content */}
//                           <button
//                             style={{
//                               backgroundColor: '#B8529E',
//                               color: 'white',
//                               border: 'none',
//                               borderRadius: '5px',
//                               padding: '10px 20px',
//                               cursor: 'pointer',
//                               marginBottom: '10px',
//                             }}
//                           >
//                             <FaChartBar /> Grades
//                           </button>
//                           <ul>
//                             <li>Academic Achievements</li>
//                             <li>Performance Overview</li>
//                             <li>Grades Report</li>
//                           </ul>
//                         </Card.Body>
//                       </Card>
//                     </div>

//                     <div className='col-md-4'>
//                       <Card className='border-0 shadow-lg'>
//                         <Card.Body style={{ textAlign: 'center' }}>
//                           {' '}
//                           {/* Center the content */}
//                           <button
//                             style={{
//                               backgroundColor: '#B8529E',
//                               color: 'white',
//                               border: 'none',
//                               borderRadius: '5px',
//                               padding: '10px 20px',
//                               cursor: 'pointer',
//                               marginBottom: '10px',
//                             }}
//                           >
//                             <FaBullseye /> Target Next Goal
//                           </button>
//                           <ul>
//                             <li>Setting Future Objectives</li>
//                             <li>Next Milestone Ahead</li>
//                             <li>Striving for Success</li>
//                           </ul>
//                         </Card.Body>
//                       </Card>
//                     </div>
//                   </div>
//                 </Card.Body>
//                 {/* </Card> */}
//               </div>
//             </div>
//           </div>

//           <div className='wrapper'>
//             {/* ... (your existing sidebar code) */}
//           </div>
//         </div>
//       </div>
//       {/* <Footer /> */}
//     </div>
//   )
// }

// export default Profile

// ****************************************************************************************************
// import React, { useState, useEffect } from 'react'
// import axios from 'axios'
// import './Sidebarr.css'
// import { createBrowserHistory } from 'history'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import Header from '../Components/Header'
// import Footer from '../Components/Footer'
// import { Card, Button, CardText, Spinner } from 'react-bootstrap'
// import {
//   faUser,
//   faList,
//   faShieldAlt,
//   faBell,
//   faColumns,
//   faTrophy,
//   faCog,
//   faEdit,
//   faSignOutAlt,
// } from '@fortawesome/free-solid-svg-icons'
// import {
//   faInstagram,
//   faTwitter,
//   faFacebook,
//   faWhatsapp,
// } from '@fortawesome/free-brands-svg-icons'
// import { FaTrophy, FaChartBar, FaBullseye } from 'react-icons/fa'
// import StudentSdebar from './StudentSdebar'
// import { motion, AnimatePresence } from "framer-motion"
// import defaultPic from '../Images/default.jpeg'
// import EditProfileModal from './EditProfileModal'

// import { useNavigate } from 'react-router-dom'

// const history = createBrowserHistory()

// const Profile = () => {
//   const [user, setUser] = useState({
//     name: '',
//     email: '',
//     bio: '',
//     profile: '',
//     tagline: '',
//   })
//   const [loading, setLoading] = useState(true)
//   const [showEditProfileModal, setEditProfileModal] = useState(false)
//   const [sidebarExpanded, setSidebarExpanded] = useState(false);
//   const navigate = useNavigate()
//   const token = localStorage.getItem('jwttoken')

//   const handleEditProfile = () => {}

//   useEffect(() => {
//     setLoading(true)
//     axios
//       .get('https://kaasbackend.vetrinahealthcare.com/lms/user/', {
//         headers: {
//           accept: 'application/json',
//           Authorization: 'Bearer ' + token,
//         },
//       })
//       .then((response) => {
//         setUser({
//           name: response.data.first_name + ' ' + response.data.last_name,
//           email: response.data.email,
//           bio: response.data.bio,
//           tagline: response.data.tagline,
//           profile: response.data.profile_pic,
//         })
//         setLoading(false)
//       })
//       .catch((error) => {
//         console.error('Error:', error.response.status)
//         if (error.response.status === 401) {
//           navigate('/Log')
//         }
//         setLoading(false)
//       })
//   }, [showEditProfileModal])

//   if (loading) {
//     return (
//       <div className='d-flex justify-content-center align-items-center' style={{ height: '100vh' }}>
//         <Spinner animation='border' variant='primary' role='status' style={{ width: '4rem', height: '4rem' }}>
//           <span className='visually-hidden'>Loading...</span>
//         </Spinner>
//       </div>
//     )
//   }

//   return (
//     <div style={{ marginTop: '0px' }}>
//       <Header />
//       <div className='container-fluid'>
//         <div className='row Profile_info_row p-0'></div>
//       </div>
//        <div className="wrapper" style={{ display: "flex" }}>
//             <StudentSdebar onToggle={setSidebarExpanded} />
      
//             <motion.div
//               className="main-content p-lg-4 p-md-3 p-2"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ duration: 0.5 }}
//               style={{
//                 marginTop: '60px', // Adjust this to match your Header height
//                 marginLeft: sidebarExpanded ? '260px' : '90px',
//                 transition: 'margin-left 0.25s ease-in-out',
//                 width: sidebarExpanded ? 'calc(100% - 260px)' : 'calc(100% - 90px)',
//                 overflowY: 'auto',
//                 height: 'calc(100vh - 60px)',
//               }}
//             >

//         <div className='main p-3' style={{ backgroundColor: 'transparent' }}>
//           <div
//             className='text-center border rounded mx-auto text-light mb-4 p-1'
//             style={{
//               background:
//                 'linear-gradient(to right, #3953A3, #7D52A0, #8852A0, #B8529E)',
//               width: '80%',
//               maxWidth: '300px',
//             }}
//           >
//             <h1 style={{ fontSize: '24px' }}>My Profile</h1>
//           </div>
//           <div className='container-fluid '>
//             <div className='row  mb-4'>
//               <div className='col-2 text-center'>
//                 <img
//                   src={user.profile ? user.profile : defaultPic}
//                   alt='User Profile'
//                   style={{
//                     height: '200px',
//                     width: '200px',
//                     borderRadius: '50%',
//                     objectFit: 'cover',
//                     border: '8px solid white',
//                     boxShadow: '0 0 0 5px white, 0 4px 8px rgba(0, 0, 0, 0.1)',
//                     marginTop: '70px',
//                     marginLeft: '10px',
//                     display: 'block',
//                     position: 'relative',
//                     zIndex: '1',
//                   }}
//                   onError={(e) => {
//                     e.target.src = defaultPic
//                   }}
//                 />
//               </div>

//               <div className='col-md-10 d-flex justify-content-center'>
//                 <Card
//                   className='border-0 shadow-lg text-start p-5'
//                   style={{ width: '100%' }}
//                 >
//                   <Card.Body>
//                     <Card.Title>
//                       <h2 className='mb-2 text-danger'>{user.name}</h2>
//                     </Card.Title>
//                     <Card.Text className='text-muted mb-4'>
//                       {user.tagline
//                         ? user.tagline
//                         : 'Turning ideas into reality, one line of code at a time. Driven by passion, powered by purpose.'}
//                     </Card.Text>
//                     <Card.Text className='lead' style={{ color: '#333' }}>
//                       {user.bio ? user.bio : user.name}
//                     </Card.Text>

//                     <div
//                       className='d-flex justify-content-end align-items-center mb-4'
//                       style={{ width: '100%' }}
//                     >
//                       <div className='d-flex justify-content-right align-items-center'>
//                         <a
//                           href=' '
//                           className='text-dark me-3'
//                           title='Instagram'
//                           onClick={() =>
//                             window.open('your-instagram-link', '_blank')
//                           }
//                         >
//                           <FontAwesomeIcon
//                             icon={faInstagram}
//                             size='2x'
//                             style={{ color: 'red' }}
//                           />
//                         </a>
//                         <a
//                           href=' '
//                           className='text-dark me-3'
//                           title='Twitter'
//                           onClick={() =>
//                             window.open('your-twitter-link', '_blank')
//                           }
//                         >
//                           <FontAwesomeIcon
//                             icon={faTwitter}
//                             size='2x'
//                             style={{ color: 'blue' }}
//                           />
//                         </a>
//                         <a
//                           href=' '
//                           className='text-dark me-3'
//                           title='Facebook'
//                           onClick={() =>
//                             window.open('your-facebook-link', '_blank')
//                           }
//                         >
//                           <FontAwesomeIcon
//                             icon={faFacebook}
//                             size='2x'
//                             style={{ color: 'blue' }}
//                           />
//                         </a>
//                         <a
//                           href=' '
//                           className='text-dark'
//                           title='WhatsApp'
//                           onClick={() =>
//                             window.open('your-whatsapp-link', '_blank')
//                           }
//                         >
//                           <FontAwesomeIcon
//                             icon={faWhatsapp}
//                             size='2x'
//                             style={{ color: 'green' }}
//                           />
//                         </a>
//                       </div>

//                       <div className='ms-auto'>
//                         {/* Uncomment below if Edit Profile modal is to be used */}
//                         {/* <Button
//                           style={{
//                             backgroundColor: '#B8529E',
//                             color: 'white',
//                             border: 'none',
//                             marginLeft: '20px',
//                             padding: '10px 20px',
//                           }}
//                           size='lg'
//                           onClick={() => setEditProfileModal(true)}
//                         >
//                           <FontAwesomeIcon icon={faUser} className='me-2' />
//                           Edit Profile
//                         </Button> */}
//                       </div>

//                       {showEditProfileModal && (
//                         <EditProfileModal
//                           setShow={setEditProfileModal}
//                           show={showEditProfileModal}
//                           onEditProfile={handleEditProfile}
//                           onClose={() => setEditProfileModal(false)}
//                         />
//                       )}
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </div>
//             </div>

//             <div className='row mb-4'>
//               <div className='col-md-12'>
//                 <Card.Body>
//                   <div className='row'>
//                     <div className='col-md-4'>
//                       <Card className='border-0 shadow-lg'>
//                         <Card.Body style={{ textAlign: 'center' }}>
//                           <button
//                             style={{
//                               backgroundColor: '#B8529E',
//                               color: 'white',
//                               border: 'none',
//                               borderRadius: '5px',
//                               padding: '10px 20px',
//                               cursor: 'pointer',
//                               marginBottom: '10px',
//                             }}
//                           >
//                             <FaTrophy /> Top Performer
//                           </button>
//                           <ul>
//                             <li>Celebrating Excellence</li>
//                             <li>Champion of the Month</li>
//                             <li>Leaderboard Leader</li>
//                           </ul>
//                         </Card.Body>
//                       </Card>
//                     </div>

//                     <div className='col-md-4'>
//                       <Card className='border-0 shadow-lg'>
//                         <Card.Body style={{ textAlign: 'center' }}>
//                           <button
//                             style={{
//                               backgroundColor: '#B8529E',
//                               color: 'white',
//                               border: 'none',
//                               borderRadius: '5px',
//                               padding: '10px 20px',
//                               cursor: 'pointer',
//                               marginBottom: '10px',
//                             }}
//                           >
//                             <FaChartBar /> Grades
//                           </button>
//                           <ul>
//                             <li>Academic Achievements</li>
//                             <li>Performance Overview</li>
//                             <li>Grades Report</li>
//                           </ul>
//                         </Card.Body>
//                       </Card>
//                     </div>

//                     <div className='col-md-4'>
//                       <Card className='border-0 shadow-lg'>
//                         <Card.Body style={{ textAlign: 'center' }}>
//                           <button
//                             style={{
//                               backgroundColor: '#B8529E',
//                               color: 'white',
//                               border: 'none',
//                               borderRadius: '5px',
//                               padding: '10px 20px',
//                               cursor: 'pointer',
//                               marginBottom: '10px',
//                             }}
//                           >
//                             <FaBullseye /> Target Next Goal
//                           </button>
//                           <ul>
//                             <li>Setting Future Objectives</li>
//                             <li>Next Milestone Ahead</li>
//                             <li>Striving for Success</li>
//                           </ul>
//                         </Card.Body>
//                       </Card>
//                     </div>
//                   </div>
//                 </Card.Body>
//               </div>
//             </div>
//           </div>
//         </div>
//         </motion.div>
//       </div>
//       {/* <Footer /> */}    
//     </div>

//   )
// }

// export default Profile
// *************************************************************************************************



import React, { useState, useEffect } from 'react'
import axios from 'axios'
import './Sidebarr.css'
import { createBrowserHistory } from 'history'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import { Card, Button, CardText, Spinner } from 'react-bootstrap'
import {
  faUser,
  faList,
  faShieldAlt,
  faBell,
  faColumns,
  faTrophy,
  faCog,
  faEdit,
  faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons'
import {
  faInstagram,
  faTwitter,
  faFacebook,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons'
import { FaTrophy, FaChartBar, FaBullseye } from 'react-icons/fa'
import StudentSdebar from './StudentSdebar'
import { motion, AnimatePresence } from "framer-motion"
import defaultPic from '../Images/default.jpeg'
import EditProfileModal from './EditProfileModal'

import { useNavigate } from 'react-router-dom'

const history = createBrowserHistory()

const Profile = () => {
  const [user, setUser] = useState({
    name: '',
    email: '',
    bio: '',
    profile: '',
    tagline: '',
  });

  const [loading, setLoading] = useState(true);
  const [showEditProfileModal, setEditProfileModal] = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('jwttoken');

  useEffect(() => {
    setLoading(true);
    axios
      .get('https://kaasbackend.vetrinahealthcare.com/lms/user/', {
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
      })
      .then((response) => {
        setUser({
          name: response.data.first_name + ' ' + response.data.last_name,
          email: response.data.email,
          bio: response.data.bio,
          tagline: response.data.tagline,
          profile: response.data.profile_pic,
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error:', error.response?.status);
        if (error.response?.status === 401) {
          navigate('/Log');
        }
        setLoading(false);
      });
  }, [showEditProfileModal]);

  return (
    <div>
      <Header />
      <div className="container-fluid">
        <div className="row Profile_info_row p-0"></div>
      </div>

      <div className="wrapper" style={{ display: 'flex' }}>
        <StudentSdebar onToggle={setSidebarExpanded} />

        <motion.div
          className="main-content p-lg-4 p-md-3 p-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          style={{
            marginTop: '60px',
            marginLeft: sidebarExpanded ? '260px' : '90px',
            transition: 'margin-left 0.25s ease-in-out',
            width: sidebarExpanded ? 'calc(100% - 260px)' : 'calc(100% - 90px)',
            overflowY: 'auto',
            height: 'calc(100vh - 60px)',
          }}
        >
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: '100%' }}
            >
              <Spinner
                animation="border"
                variant="primary"
                role="status"
                style={{ width: '4rem', height: '4rem' }}
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <div className="main p-3" style={{ backgroundColor: 'transparent' }}>
              <div
                className="text-center border rounded mx-auto text-light mb-4 p-1"
                style={{
                  background: 'linear-gradient(to right, #3953A3, #7D52A0, #8852A0, #B8529E)',
                  width: '80%',
                  maxWidth: '300px',
                }}
              >
                <h1 style={{ fontSize: '24px' }}>My Profile</h1>
              </div>

              <div className="container-fluid">
                <div className="row mb-4">
                  <div className="col-2 text-center">
                    <img
                      src={user.profile || defaultPic}
                      alt="User Profile"
                      style={{
                        height: '200px',
                        width: '200px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: '8px solid white',
                        boxShadow: '0 0 0 5px white, 0 4px 8px rgba(0, 0, 0, 0.1)',
                        marginTop: '70px',
                        marginLeft: '10px',
                        display: 'block',
                        position: 'relative',
                        zIndex: '1',
                      }}
                      onError={(e) => {
                        e.target.src = defaultPic;
                      }}
                    />
                  </div>

                  <div className="col-md-10 d-flex justify-content-center">
                    <Card className="border-0 shadow-lg text-start p-5" style={{ width: '100%' }}>
                      <Card.Body>
                        <Card.Title>
                          <h2 className="mb-2 text-danger">{user.name}</h2>
                        </Card.Title>
                        <Card.Text className="text-muted mb-4">
                          {user.tagline ||
                            'Turning ideas into reality, one line of code at a time. Driven by passion, powered by purpose.'}
                        </Card.Text>
                        <Card.Text className="lead" style={{ color: '#333' }}>
                          {user.bio || user.name}
                        </Card.Text>

                        <div className="d-flex justify-content-end align-items-center mb-4">
                          <div className="d-flex">
                            <a
                              href="#"
                              className="text-dark me-3"
                              title="Instagram"
                              onClick={() => window.open('your-instagram-link', '_blank')}
                            >
                              <FontAwesomeIcon icon={faInstagram} size="2x" style={{ color: 'red' }} />
                            </a>
                            <a
                              href="#"
                              className="text-dark me-3"
                              title="Twitter"
                              onClick={() => window.open('your-twitter-link', '_blank')}
                            >
                              <FontAwesomeIcon icon={faTwitter} size="2x" style={{ color: 'blue' }} />
                            </a>
                            <a
                              href="#"
                              className="text-dark me-3"
                              title="Facebook"
                              onClick={() => window.open('your-facebook-link', '_blank')}
                            >
                              <FontAwesomeIcon icon={faFacebook} size="2x" style={{ color: 'blue' }} />
                            </a>
                            <a
                              href="#"
                              className="text-dark"
                              title="WhatsApp"
                              onClick={() => window.open('your-whatsapp-link', '_blank')}
                            >
                              <FontAwesomeIcon icon={faWhatsapp} size="2x" style={{ color: 'green' }} />
                            </a>
                          </div>
                        </div>

                        {showEditProfileModal && (
                          <EditProfileModal
                            setShow={setEditProfileModal}
                            show={showEditProfileModal}
                            onEditProfile={() => {}}
                            onClose={() => setEditProfileModal(false)}
                          />
                        )}
                      </Card.Body>
                    </Card>
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-12">
                    <Card.Body>
                      <div className="row">
                        <div className="col-md-4">
                          <Card className="border-0 shadow-lg">
                            <Card.Body style={{ textAlign: 'center' }}>
                              <button
                                style={{
                                  backgroundColor: '#B8529E',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '5px',
                                  padding: '10px 20px',
                                  marginBottom: '10px',
                                }}
                              >
                                <FaTrophy /> Top Performer
                              </button>
                              <ul>
                                <li>Celebrating Excellence</li>
                                <li>Champion of the Month</li>
                                <li>Leaderboard Leader</li>
                              </ul>
                            </Card.Body>
                          </Card>
                        </div>

                        <div className="col-md-4">
                          <Card className="border-0 shadow-lg">
                            <Card.Body style={{ textAlign: 'center' }}>
                              <button
                                style={{
                                  backgroundColor: '#B8529E',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '5px',
                                  padding: '10px 20px',
                                  marginBottom: '10px',
                                }}
                              >
                                <FaChartBar /> Grades
                              </button>
                              <ul>
                                <li>Academic Achievements</li>
                                <li>Performance Overview</li>
                                <li>Grades Report</li>
                              </ul>
                            </Card.Body>
                          </Card>
                        </div>

                        <div className="col-md-4">
                          <Card className="border-0 shadow-lg">
                            <Card.Body style={{ textAlign: 'center' }}>
                              <button
                                style={{
                                  backgroundColor: '#B8529E',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '5px',
                                  padding: '10px 20px',
                                  marginBottom: '10px',
                                }}
                              >
                                <FaBullseye /> Target Next Goal
                              </button>
                              <ul>
                                <li>Setting Future Objectives</li>
                                <li>Next Milestone Ahead</li>
                                <li>Striving for Success</li>
                              </ul>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </Card.Body>
                  </div>
                </div>
              </div>
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default Profile;